import React from "react";
import styled from "styled-components";
import LightSubtitle from "../../components/shared/text/LightSubtitle";
import { smMedia } from "../../utils/getMediaStyle";

const IntegrationContainer = styled.div`
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.color.secondary.main};
`;
const LogoList = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;
const Logo = styled.img`
  ${smMedia`
    max-width: 88px
  `}
  max-width: 200px;
  filter: brightness(0) invert(1);
`;

const Integration = (props) => {
  return (
    <IntegrationContainer className="d-flex flex-column" {...props}>
      <LightSubtitle className="text-center">
        Copysmith integrates beautifully with
      </LightSubtitle>
      <LogoList className="d-flex mt-5">
        <Logo
          class="img-fluid"
          src="https://strategyvii.com/wp-content/uploads/2018/08/shopify-logo-white.png"
          alt="Shopfy"
        ></Logo>
        <Logo
          class="img-fluid"
          src="https://s.w.org/style/images/about/WordPress-logotype-alternative-white.png"
          alt="Wordpress"
        ></Logo>
        <Logo
          class="img-fluid"
          src="https://imgur.com/IonMMJ8.png"
          alt="Gmail"
        ></Logo>
      </LogoList>
    </IntegrationContainer>
  );
};

export default Integration;
